import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { UrlPath } from "../../../config/routeConfig";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { TopBar } from "../../shared/topBar/TopBar";
import { ToastContainer, toast } from "react-toastify";
import {
  insertorupdateInvestorTracking,
  getAllFamilies,
  getPortfoliosByFamily,
  getInvestorStatus,
  getassetclassbyType,
  getshareclassbyType,
  gettrackingdetails,
  getBulkUpdateDetails,
  insertBulkUpdate
} from "../../../config/apiConfig";
import { sbaAxios } from "../../utils/sbaAxios";
import { AgGridReact } from "ag-grid-react";
import { Modal } from "react-bootstrap";
import { SBADrawer } from "../../UiComponents/SBADrawer";
import {
  SBAComboBox,
  SBADropDown,
  SBAMultiSelect,
} from "../../UiComponents/SBADropDown";
import CurrencyInput from "react-currency-input-field";
import { SBDatePicker } from "../../UiComponents/SBDatePicker";
import moment from "moment";
import { SBNotify } from "../../utils/sbNotify";
export const BulkUpload = () => {
  const Level = [
    { BreadCrumb: "Investor >", Routes: `${UrlPath.Investor}` },
    { BreadCrumb: "Tracker >", Routes: `${UrlPath.InvestorTracking}` },
    {
      BreadCrumb: "Bulk Update",
      Routes: `${UrlPath.InvestorTrackingSubscription}`,
    },
  ];
  const [status, setStatus] = useState();
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [transactionDate, setTransactionDate] = useState(new Date());
  const [gridAPI, setGridAPI] = useState(null);
  const [originalGridData, setOriginalGridData] = useState([]); // Store original data
  const [gridData, setGridData] = useState([]);
  const [overrideDate, setOverrideDate] = useState(false);
  const [overrideStatus, setOverrideStatus] = useState(false);
  const locationData = useLocation(); 
  const investorTrackingIds = locationData.state !==null? locationData.state.investorTrackingIds === undefined ? null : locationData.state.investorTrackingIds:null;
  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Bulk Update";

    getStatus();
  }, []);

  const onGridReady = (params) => {
    setGridAPI(params.api);
  };

  const getStatus = async() => {
    await sbaAxios({
      url: `${getInvestorStatus}`,
      method: "get",
    }).then((response) => {
      setStatus(response);
      setSelectedStatus(response[0]);
    });
  };

  const fetchBulkUpdateDetails = async(queryParams) => {
    try{
        const list = await sbaAxios({
            url: `${getBulkUpdateDetails}`,
            params:{
                investorTrackingIdList:queryParams
            }
        });
        setGridData(list);
        setOriginalGridData(list);
    }
    catch(e){
        console.error(e);
        setGridData([]);
    }
  };

  useEffect(()=>{
    if(investorTrackingIds?.length > 0){
        const qParams = investorTrackingIds?.join(',');
        fetchBulkUpdateDetails(qParams);
    }
  },[investorTrackingIds]);

  useEffect(()=>{
    console.log('griddata: ', gridData)
  },[gridData]);

  const getFormattedDate = (params) => {
    return params.value ? moment(params.value).format("MM-DD-YYYY") : "";
  };
  const ColDefs = [
    { headerName: "Transaction Date", field: "TransactionDate", valueFormatter: getFormattedDate,},
    {
      headerName: "Status",
      field: "InvestorTrackingStatusName",
      
    },
    { headerName: "Portfolio", field: "PortfolioName" },
    { headerName: "Asset", field: "AssetName", editable: false },
    {
      headerName: "Amount",
      field: "TransactionAmount",
      valueFormatter: (params) => new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(params.value),
      cellStyle: { textAlign: "right" },
    },
  ];

  const handleOverrideChange = (type, isChecked) => {
    if (!gridAPI) return;
  
    const updatedRows = gridData.map((row) => {
      const originalRow = originalGridData.find((r) => r.id === row.id) || row;
      const updatedData = { ...row };
  
      if (type === "date") {
        if (isChecked) {
          updatedData.TransactionDate = moment(transactionDate).format("MM-DD-YYYY");
        } else {
          updatedData.TransactionDate = originalRow.TransactionDate;
        }
      }
  
      if (type === "status") {
        if (isChecked) {
          updatedData.InvestorTrackingStatusName = selectedStatus?.InvestorTRackingStatusName;
        } else {
          updatedData.InvestorTrackingStatusName = originalRow.InvestorTrackingStatusName;
        }
      }
  
      return updatedData;
    });
  
    gridAPI.applyTransaction({ update: updatedRows });
  
    setGridData(updatedRows); // Ensure UI updates correctly
  
    if (type === "date") setOverrideDate(isChecked);
    if (type === "status") setOverrideStatus(isChecked);
  };

    const handleBulkUpdate = async () => {
    const postData = gridData.map((item)=>{
        return{
            investorTrackingId:item.InvestorTrackingId,
            transactionDate: moment(item.TransactionDate).format("YYYY-MM-DD"),
            investorTrackingStatusId:status?.find((stat) => stat?.InvestorTRackingStatusName === item.InvestorTrackingStatusName).InvestorTrackingStatusId
        }
    });
    //console.log('post data: ', postData);
    try{
        await sbaAxios({
            url:insertBulkUpdate,
            method:'post',
            data:postData
        });
        toast.success('Transaction details updated successfully.')
        setTimeout(() => {
            navigate(UrlPath.InvestorTracking) 
        }, 3000);
    }
    catch(e){
        console.error(e);
        toast.error('Unable to update transaction.')
    }
  }

  return (
    <>
      <TopBar label={"Investor Tracker"} />
      <div id="InvestorTrackingList" className="mainContentData">
        <BreadCrumbs Levels={Level} />
        <div className="container-fluid">
          <div className="bg-white m-4 mb-3 p-3 border rounded">
              <div className="row">
                <div className="col-4">
                  <label className="label">Transaction Date</label>
                  <SBDatePicker
                    className="w-100"
                    value={moment(transactionDate)}
                    onChange={(newDate) => {
                        setTransactionDate(newDate)
                        if (overrideDate) handleOverrideChange("date", true);
                    }}
                  />
                </div>
                <div className="col-4">
                  <label className="label">
                    Status<span className="mandatory">*</span>
                  </label>
                  <div>
                    <SBAComboBox
                      className="w-100"
                      data={status}
                      textField={"InvestorTRackingStatusName"}
                      valueField={"InvestorTrackingStatusId"}
                      value={selectedStatus}
                      onChange={(e) => {
                        setSelectedStatus(e.value)
                        if (overrideStatus) handleOverrideChange("status", true);
                    }}
                    ></SBAComboBox>
                  </div>
                </div>
            </div>
               <div className="row mt-2  mb-4">
                <div className="col-4">
                <label>
                    <input
                        type="checkbox"
                        checked={overrideDate}
                        onChange={(e) => handleOverrideChange("date", e.target.checked)}
                        style={{marginRight:'5px'}}
                    />
                     Override Date
                    </label>
                </div>
                <div className="col-4">
                <label>
                    <input
                        type="checkbox"
                        checked={overrideStatus}
                        onChange={(e) => handleOverrideChange("status", e.target.checked)}
                        style={{marginRight:'5px'}}
                    />
                    Override Status
                    </label>
                </div>
            </div>
                <div className="d-flex justify-content-end gap-2">
                  {/*<button type="button" className="p-sm-btn mx-1 mb-5">*/}
                  {/*  Apply*/}
                  {/*</button>*/}
                </div>
                <div
                className="ag-theme-alpine"
                  style={{ height: "300px", width: "100%", paddingTop: 0 }}
                >
                  <AgGridReact
                    rowData={gridData}
                    onGridReady={onGridReady}
                    columnDefs={ColDefs}
                    defaultColDef={{
                      resizable: true,
                      sortable: true,
                      filter: true,
                      flex: 1,
                    }}
                    rowSelection="single"
                  />
                </div>
                <div className="d-flex justify-content-end gap-2 mt-3">
                  <button
                    className="s-sm-btn"
                    onClick={() => {
                      navigate(UrlPath.InvestorTracking);
                    }}
                  >
                    Cancel
                  </button>
                  <button className="p-sm-btn" onClick={handleBulkUpdate}>Save</button>
                </div>
          </div>
        </div>
      </div>
      <ToastContainer/>
    </>
  );
};
